export const getOverrides = (
  paperWidth,
  sideBarIsOpen,
  paperHeight,
  stickyTD,
  stickyCol,
  hideToolBar,
  palette,
  isDesktop,
  isTablet,
  isMobile,
  isSequenceTable
) => {
  const bg = palette.mode === 'light' ? '#ffffff' : '#0C1721';
  return {
    MUIDataTable: {
      paper: {
        ...(!isMobile && !isTablet
          ? {
              maxWidth: `calc(100vw - ${
                paperWidth.substr(0, paperWidth.length - 2) - (sideBarIsOpen ? 0 : 175)
              }px)`,
            }
          : {}),
        transition: 'max-width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
        boxShadow: 'none',
        background: 'transparent',
      },
      responsiveBase: {
        maxHeight: `calc(100vh - ${paperHeight}) !important`,
        backgroundColor: bg,
        borderRadius: 0,
        // padding: palette.mode === 'light' ? '0px' : '0px',
        ...(palette.mode === 'dark'
          ? {
              border: '1px solid #203244',
              borderRadius: '8px',
              borderBottomLeftRadius: '0px',
              borderBottomRightRadius: '0px',
            }
          : {
              borderRadius: '4px',
            }),

        '&::-webkit-scrollbar': {
          width: 4,
        },
        '&::-webkit-scrollbar-track': {
          borderRadius: 4,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: palette.mode === 'light' ? '#dddddd' : '#1B3C59',
          borderRadius: 6,
        },
      },
    },
    MuiTableRow: {
      hover: {},
      root: {},
    },
    MuiTableRowHover: {
      hover: {},
    },
    MuiSelected: {},
    MuiTablePagination: {
      caption: {
        fontFamily: ['Roboto', 'sans-serif'].join(','),
      },
      actions: {
        minWidth: 100,
      },
    },
    MuiTableHead: {
      root: {
        ...(palette.mode === 'dark'
          ? {
              ...(palette.mode === 'dark' ? { borderBottom: '1px solid #203244' } : {}),
              '& .MuiTableRow-root .MuiTableCell-head:first-child': {
                borderTopLeftRadius: '8px',
              },
              '& .MuiTableRow-root .MuiTableCell-head:last-child': {
                borderTopRightRadius: '8px',
              },
            }
          : {}),

        [`& th:nth-of-type(${stickyTD})`]: stickyCol
          ? {
              whiteSpace: 'nowrap',
              position: 'sticky',
              left: stickyTD === 1 ? 0 : 42,
              zIndex: 101,
            }
          : {},
      },
    },
    MuiTableBody: {
      root: {
        [`& td:nth-of-type(${stickyTD})`]: stickyCol
          ? {
              whiteSpace: 'nowrap',
              position: 'sticky',
              left: stickyTD === 1 ? 0 : 42,
              zIndex: 100,
            }
          : {},
        '& .mui-row-selected': {
          // background: '#ffffff !important',
          [`& td:nth-of-type(${stickyTD})`]: stickyCol
            ? {
                background: '#ffffff',
              }
            : {},
        },
        '& tr': {
          height: 50,
        },
      },
    },
    MuiTableCell: {
      root: {
        padding: '11px 4px !important',
        color: palette.text.secondary,
        borderColor: palette.mode === 'light' ? 'rgba(224, 224, 224, 1)' : '#1B3C59',
      },
    },
    '& .MUIDataTableHeadCell-sortAction': {
      sortAction: {
        // color: 'rgba(0, 0, 0, 0.38) !important',
      },
    },
    MUIDataTableSelectCell: {
      headerCell: {
        // backgroundColor: 'blue',
      },
    },
    MUIDataTableToolbar: {
      left: { display: 'none' },
      root: hideToolBar
        ? { display: 'none' }
        : {
            padding: 0,
            '& .MUIDataTableSearch-searchBox': {
              // backgroundColor: '#ffffff',
            },
          },
    },
    MUIDataTableToolbarSelect: {
      root: {
        boxShadow: 'none',
        borderRadius: 0,
        border: `none`,
        borderBottom: 'none',
        justifyContent: 'start',
        backgroundColor: 'transparent',
        '& :nth-of-type(1)': {
          '& h6': {
            display: 'none',
          },
        },
      },
    },
    MUIDataTableSelectCell: {},
    MuiTableFooter: {
      root: {
        backgroundColor: palette.mode === 'dark' ? '#090D11' : 'transparent',
        '& .MuiTableRow-root': {
          ...(palette.mode === 'dark' && {
            padding: '10px',
            display: 'block',
            border: '1px solid #1B3C59',
            borderTopWidth: 0,
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
          }),
        },
      },
    },
    MUIDataTableHeadCell: {
      root: {
        backgroundColor: palette.mode === 'dark' ? '#090D11' : isSequenceTable ? 'rgba(25, 118, 210, 0.08)': palette.background.paper,
        padding: palette.mode === 'dark' ? '16px 4px !important' : '4px !important',
        borderRadius: 0,
        ...(palette.mode === 'dark' ? { borderBottom: '1px solid #203244' } : {}),
        color: palette.text.primary,
        ...(palette.mode === 'dark' && {
          border: 'none',
          '&:hover': {
            backgroundColor: palette.mode === 'dark' ? '#090D11' : !isSequenceTable ? 'rgba(25, 118, 210, 0.08)': palette.background.paper,
          },
          '&::before': {
            content: '""',
            display: 'block',
            backgroundColor: bg,
            width: '100%',
            height: '20px',
            position: 'absolute',
            top: '-20px',
            left: 0,
          },
        }),
      },
    },
  };
};
